import React from 'react';
import {
  defineOrderStatusClassName,
  getOrderStatusMainLabel,
  renderOrderStatusAdminLabel,
} from '../../../../utils/adminOrderService';
import AdminOrderPaymentStatusDropdownMobile from './AdminOrderPaymentStatusDropdownMobile';

/**
 * Мобільний блок: статус замовлення + статус оплати (випадайки).
 * Одна розмітка для списку замовлень і картки замовлення.
 */
const AdminOrderStatusAndPaymentMobile = ({
  order,
  orderStatusesEnum,
  paymentStatusesEnum,
  onPickOrderStatus,
  onPickPaymentStatus,
}) => (
  <div>
    <div className='dropdown'>
      <div
        data-toggle='dropdown'
        aria-expanded='false'
        className='d-flex flex-column align-items-start'
      >
        <span className={defineOrderStatusClassName(order.orderStatus)}>
          {getOrderStatusMainLabel(order.orderStatus)}
        </span>
        {renderOrderStatusAdminLabel(order.orderStatus) && (
          <div style={{ marginTop: 0, lineHeight: 1.1 }}>
            {renderOrderStatusAdminLabel(order.orderStatus)}
          </div>
        )}
      </div>
      <div className='dropdown-menu dropdown-menu-right order-status'>
        {orderStatusesEnum
          .filter((s) => s.adminValue !== order.orderStatus.adminValue)
          .map((status, index) => (
            <a
              key={index}
              className='dropdown-item'
              onClick={() => onPickOrderStatus(status)}
            >
              {status.adminValue}
            </a>
          ))}
      </div>
    </div>
    <AdminOrderPaymentStatusDropdownMobile
      order={order}
      paymentStatusesEnum={paymentStatusesEnum}
      onPickPaymentStatus={onPickPaymentStatus}
    />
  </div>
);

export default AdminOrderStatusAndPaymentMobile;
